<template lang="pug">
.judgement-template-preview-modal
  b-modal(v-model="_value" size="xl" @cancel="cancel" no-close-on-backdrop no-close-on-esc)
    div(slot="modal-title")
      span {{ templateName }}
    
    .mb-2
    .template-container(v-if="template")
      .information.mb-2(v-if="templateInformation" style="white-space: pre-wrap; word-wrap: break-word;") {{ templateInformation }}
      .template(v-for="(property, index) in template.properties")
        WaiterJudgeTemplateInputItem(v-model="template.properties[index]" :isChaild="false")

    template(#modal-footer="{ cancel }")
      b-button.btn.modal-cancel-btn(@click="cancel") 閉じる
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

import WaiterJudgeTemplateInputItem from "@/pc/containers/waiters/WaiterJudgeTemplateInputItem.vue";
import { Template } from "@/commons/services/AdmissionJudgementTemplates";

/**
 * ### 入居判定テンプレートプレビューモーダル
 */
@Component({
  components: {
    WaiterJudgeTemplateInputItem
  }
})
export default class JudgementTemplatePreviewModal extends Vue {
  /** 表示可否 */
  @Prop({ required: true })
  value!: boolean;
  /** モーダルタイトルで使用するテンプレート名 */
  @Prop()
  templateName!: string;
  /** テンプレート */
  @Prop()
  template!: Template;
  /** テンプレート説明文 */
  @Prop()
  templateInformation!: string;

  get _value(): boolean {
    return this.value;
  }

  set _value(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }

  public cancel(): void {
    return;
  }
}
</script>

<style lang="scss" scoped></style>
